import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { getWalletTxnWithFilterForAgencyFailure, getWalletTxnWithFilterForAgencySuccess } from '../actions/getWalletTxnWithFilterForAgencyActions';

function* getWalletTxnWithFilterForAgency({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.getWalletTxnWithFilterForAgency,
            payload: payload,
            isAuth: true
        });
        console.log('====================================');
        console.log("GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_SUCCESS status :", response.data.status);
        console.log("GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_SUCCESS data :", response.data.response);
        console.log("GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getWalletTxnWithFilterForAgencySuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        if (callback) {
            callback(
                response?.data?.status,
                response?.data?.response,
                response?.data?.message
            ); // Pass the response data to the callback
        }
    } catch (error) {
        console.log('====================================');
        console.log("GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_FAILURE status :", error?.response?.status);
        console.log("GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_FAILURE data:", error?.response?.data);
        console.log("GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_FAILURE error :", error);
        console.log('====================================');
        yield put(getWalletTxnWithFilterForAgencyFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getWalletTxnWithFilterForAgencySaga() {
    yield takeLatest(actionTypes.GET_WALLET_TXN_WITH_FILTER_FOR_AGENCY_REQUEST, getWalletTxnWithFilterForAgency);
}

export default getWalletTxnWithFilterForAgencySaga;
